import InlinePromoForm from './InlinePromoForm';

export * from './InlinePromoForm';
export default InlinePromoForm;
